import globalEvents from '@/services/GlobalEvents/GlobalEvents.ts';
import { Events } from '@/services/GlobalEvents/constants.ts';
import { ILoadFileNotify } from './IFileMessage.ts';

export const loadFileNotify = (props: ILoadFileNotify) => {
  globalEvents.emit(Events.loadFileMessage, props)
}
